import React, { useContext, useEffect, useState } from "react";

import { Box, Typography, TextField, Button } from "@material-ui/core";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import InputMask from "react-input-mask";

import useStyles from "../../styles";
import apiV2 from "../../../../../../api/api-client-v2";
import { toast } from "react-toastify";
import { AutoRegistrationContext } from "../../../../context/AutoRegistrationProvider";

export const ConfirmTwo = ({ changeStep }) => {
  const classes = useStyles();
  const [code, setCode] = useState("");
  const [errorCode, setErrorCode] = useState(false);
  const [codeSended, setCodeSended] = useState(false);
  const [tempCode, setTempCode] = useState(30);
  const [intervalCode, setIntervalCode] = useState(null);

  const { data, setData } = useContext(AutoRegistrationContext);

  const phoneNumber = data?.phoneNumber;

  const handleConfirmPhoneNumber = () => {
    setErrorCode(false);
    apiV2
      .post("twilio/checkCode", {
        phone: `+${phoneNumber?.replaceAll(/\D/g, "")}`,
        code: code?.replaceAll(/\D/g, ""),
      })
      .then(() => {
        setData({
          ...data,
          phoneNumber: `+${phoneNumber?.replaceAll(/\D/g, "")}`,
        });
        setCodeSended(true);
      })
      .catch(({ response }) => {
        setErrorCode(true);
        setCodeSended(false);
        setCode("");
        toast.error(
          response?.data?.title === "Invalid code"
            ? "Código Inválido, tente novamente."
            : "Houve um erro, tente novamente."
        );
      });
  };

  useEffect(() => {
    if (!codeSended) return;

    const formatData = {
      user_type: data?.typeClient,
      person_type: data?.typeDocument,
      document_number: data?.cpf
        ? data?.cpf.replaceAll(/\D/g, "")
        : data?.cnpj
        ? data?.cnpj.replaceAll(/\D/g, "")
        : data?.documentInternational.replace(/[^a-zA-Z0-9]/g, ""),
      branch_id: data?.branches,
      first_name: data?.firstname,
      last_name: data?.lastname,
      corporate_name: data?.company,
      email: data?.email,
      country: !data?.documentInternational ? data?.country : '',
      state: !data?.documentInternational ? data?.state : '',
      city_id:!data?.documentInternational ? data?.city : null,
      phone_number: data?.phoneNumber,
    };

    apiV2
      .post("users/signups", formatData)
      .then(() => {
        changeStep(3);
      })
      .catch(({ response }) => {
        setCode("");
        setCodeSended(false);
        toast.error(
          response?.data?.invalid_params?.document_number?.includes(
            "must be unique"
          )
            ? "Usuário já cadastrado"
            : "Erro ao realizar Cadastro"
        );
      });
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [codeSended, data]);

  const handleGoBack = () => {
    changeStep(1);
  };

  const handleResendCode = () => {
    if (tempCode > 0) return;

    apiV2
      .post("twilio/verify", {
        phone: `+${phoneNumber?.replaceAll(/\D/g, "")}`,
      })
      .then(({ data }) => {
        if (data.title === "Code sent successfully") {
          toast.success(`Código reenviado`);
          startIntervalCode();
        } else {
          toast.error(data.title);
        }
      })
      .catch(() => toast.error("Houve um erro ao gerar o código!"));
  };

  const startIntervalCode = () => {
    setTempCode(30);

    setIntervalCode(
      setInterval(() => {
        setTempCode((previewState) => previewState - 1);
      }, 1000)
    );
  };

  useEffect(() => {
    if (!intervalCode) startIntervalCode();
    if (tempCode <= 1) {
      setTempCode(0);
      clearInterval(intervalCode);
    }
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [tempCode]);

  const isDisabledBtn = () => {
    const onlyNumber = code?.replaceAll("_", "")?.replaceAll(" ", "");
    if (onlyNumber.length === 6) {
      return false;
    }
    return true;
  };

  return (
    <Box className={classes.form}>
      <Box className={classes.registrationContainer}>
        <Box className={classes.title}>
          <Typography>Etapa 2 de 2</Typography>
          <Typography variant="h4">Confirme seu número de celular</Typography>
        </Box>

        <Box className={classes.inputContainerConfirm}>
          <Typography className={classes.infoTextConfirm}>
            Informe o código enviado para {phoneNumber}
          </Typography>
          <InputMask
            alwaysShowMask
            mask="  9  9  9  9  9  9  "
            value={code}
            onChange={({ target }) => {
              setErrorCode(false);
              setCode(target.value);
            }}
          >
            <TextField error={errorCode} variant="outlined" />
          </InputMask>
          {errorCode && (
            <Typography className={classes.textErrorCode}>
              O código inserido não está correto.
            </Typography>
          )}
        </Box>

        <Box className={classes.inputContainerConfirm}>
          {tempCode >= 1 ? (
            <>
              <Typography style={{ color: "#26975A" }}>
                Reenviar código em {tempCode}s
              </Typography>
              <Typography>Código válido por 10 minutos</Typography>
            </>
          ) : (
            <Button
              id="resendCode-btn"
              data-cy="resendCode-btn"
              variant="contained"
              className={classes.resendCodeBtn}
              size="large"
              type="button"
              onClick={handleResendCode}
            >
              Reenviar código
            </Button>
          )}
        </Box>

        <Box className={classes.actionButtons}>
          <Button
            id="goBack-btn"
            data-cy="goBack-btn"
            variant="outlined"
            className="goBack"
            color="primary"
            type="button"
            size="large"
            onClick={handleGoBack}
          >
            <ArrowBackIosIcon /> Voltar
          </Button>
          <Box className="goNext">
            *Preenchimento obrigatório.
            <Button
              id="next-btn"
              data-cy="next-btn"
              variant="contained"
              className="next"
              color="primary"
              size="large"
              type="button"
              onClick={handleConfirmPhoneNumber}
              disabled={isDisabledBtn()}
            >
              Continuar
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
